import { type SelectOption } from "@certa/catalyst/components/Select";

export const filterFieldOption = (option: SelectOption, inputValue: string) => {
  return typeof option.label === "string"
    ? option.label?.toLowerCase()?.includes(inputValue?.toLowerCase())
    : false;
};
